module.exports = __webpack_public_path__ + "static/marche-3b61b5cb4800ab8c934ba64d6fc8511d.jpg";